// extracted by mini-css-extract-plugin
module.exports = {"header":"PageHeader_header__1s-tJ","title":"PageHeader_title__QyUnq"};